/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, inject, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { DtcListComponent } from '../../../lists/dtc/dtc-list/dtc-list.component';
import { Dtc } from '../../../../../shared/models/dtc/dtc';
import { STORAGE_KEYS } from '../../../../../shared/constants/storage-keys';
import { CrudOverviewBaseComponent } from '../../../base/crud-overview-base.component';
import { DtcApiService } from '../../../../services/api/dtc-api.service';
import { DtcQuery } from '../../../../../shared/models/dtc/dtc-query';
import { PaginationService } from '../../../../services/pagination.service';

@Component({
  selector: 'app-linked-dtcs',
  imports: [DtcListComponent],
  templateUrl: './linked-dtcs.component.html',
  styleUrl: './linked-dtcs.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [PaginationService],
})
export class LinkedDtcsComponent extends CrudOverviewBaseComponent<Dtc> implements OnInit, OnChanges {
  @Input() public errorMessageId?: string;

  private readonly dtcApi = inject(DtcApiService);
  private debouncer: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    super(STORAGE_KEYS.NONE);
  }

  public override ngOnInit(): void {
    super.ngOnInit();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['errorMessageId'] && this.debouncer) {
      clearTimeout(this.debouncer);
    }
    this.debouncer = setTimeout(() => {
      this.getLinkedDtcs();
    }, 50);
  }

  public onScrolledToBottom(): void {
    const query: DtcQuery = {
      errorMessageId: this.errorMessageId,
    };
    this.fetchDtcs(query, false);
  }

  protected override handleNewSelection(id: string): void {
    throw new Error('Method not implemented.');
  }

  protected override getFriendlyItemName(item?: Dtc | undefined): string {
    throw new Error('Method not implemented.');
  }

  protected override configureDetailsView(item: Dtc): void {
    throw new Error('Method not implemented.');
  }

  private getLinkedDtcs(): void {
    if (this.errorMessageId) {
      const query: DtcQuery = {
        errorMessageId: this.errorMessageId,
      };
      this.fetchDtcs(query, true);
    }
  }

  private fetchDtcs(query: DtcQuery, resetPagination: boolean): void {
    this.fetchPagedData(resetPagination, (page, pageSize) => {
      query.page = page;
      query.pageSize = pageSize;
      return this.dtcApi.getDtcs(query);
    });
  }
}
